import { l } from '@manychat/manyui'

import { billing, UpgradeSource } from 'common/billing'
import { alert } from 'common/core'
import { Ability } from 'common/core/constants/Ability'
import { settingsApi } from 'shared/api/requests/settings'
import { createAsyncAction } from 'shared/lib/redux'
import { analyticsService } from 'utils/services/analytics'

export const switchEmailChannel = createAsyncAction(
  'settings/switchEmailChannel',
  async (value: boolean) => {
    const response = await settingsApi.email.switchEmailChannel({
      body: { value },
    })

    analyticsService.sendEvent(response.data ? 'SETTINGS.EMAIL_ENABLED' : 'SETTINGS.EMAIL_DISABLED')

    document.location.reload()

    return response.data
  },
  {
    onBusinessError: (error) => {
      if (billing.isProError(error)) {
        error.handle()
        billing.handleProError(error, {
          source: UpgradeSource.EMAIL,
          message: l.translate(
            "You aren't able to connect Email channel on the current plan. Upgrade for unlimited access.",
          ),
          title: l.translate(`Unlock the ability to connect Email channel with Manychat Pro`),
          abilities: [Ability.EMAIL_CHANNEL],
        })
      }
    },
  },
)

export const setEmailSettings = createAsyncAction(
  'settings/setEmailSettings',
  async (payload: { company_name: string; address: string }) => {
    const response = await settingsApi.email.setEmailSettings({
      body: { company_name: payload.company_name, address: payload.address },
    })

    return response.data
  },
  {
    onBusinessError: (error) => {
      if (billing.isProError(error)) {
        error.handle()
        billing.handleProError(error, {
          source: UpgradeSource.EMAIL,
          abilities: [Ability.EMAIL_CHANNEL],
        })
      }

      if (settingsApi.email.setEmailSettings.isAddressBlankError(error)) {
        error.handle()
        alert(error?.message, 'danger')
      }
    },
  },
)

export const showEmailBranding = createAsyncAction(
  'settings/showEmailBranding',
  async (payload: { value: boolean }) => {
    const response = await settingsApi.email.showEmailBranding({
      body: { value: payload.value },
    })

    return response.data
  },
  {
    onBusinessError: (error) => {
      if (billing.isProError(error)) {
        error.handle()
        billing.handleProError(error, {
          source: UpgradeSource.EMAIL,
          title: l.translate('Unlock the ability to disable Branding in  with Manychat Pro'),
          message: l.translate(
            "You aren't able to disable branding on the current plan. Upgrade for unlimited access.",
          ),
          abilities: [Ability.EMAIL_CHANNEL],
        })
      }
    },
  },
)
